// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"248":"16e28610c5338dae","251":"3ad693a9cfdcb8b5","342":"26e1bb4e98bf4d2b","912":"17689d09aa7fbb52"}[chunkId] + ".js";
};